import React, { useState, useEffect, useRef } from "react"
import { Link, withRouter, useHistory } from "react-router-dom"
import PropTypes from 'prop-types'
import { Modal, Toggle } from "rsuite"
import axios from "axios"
import Swal from "sweetalert2"
import {
	Button,
	Card,
	CardBody,
	CardSubtitle,
	CardTitle,
	Col,
	Container,
	Form,
	FormGroup,
	Input,
	Label,
	Row
} from "reactstrap"

//GraphQL
import { Insert_Brand_One, Update_Brand_One } from "gql/Mutation"
import { useMutation } from "@apollo/client"

//Import Breadcrumb
import FileUploader from "components/Common/FileUploader"

const EcommerceCreateBrand = (props) => {
	const history = useHistory()
	const [CreateBrandMutation] = useMutation(Insert_Brand_One)
	const [UpdateBrandMutation] = useMutation(Update_Brand_One)
	const [name, setName] = useState("")
	const [image, setImage] = useState(null)
	const [btnLoading, setBtnLoading] = useState(false)
	const [isActive, setActive] = useState(true)

	const handleUploadFile = async () => {
		return new Promise(async (resolve, reject) => {
			try {
				let formData = new FormData()
				formData.append("uploads", image[0])
				const resp = await axios.post(`${process.env.REACT_APP_SERVICE_BASE_URL}user/userimage/public`, formData)
				if (resp.data?.success) {
					if (Array.isArray(resp.data?.data?.uploaded_files)) {
						const link = resp.data.data.uploaded_files[0].uploaded_file_url
						resolve(link)
					}
				} else {
					resolve(null)
				}
			} catch (err) {
				resolve(null)
			}
		})
	}
	const handleCreateBrand = async (e) => {
		try {
			e.preventDefault()
			setBtnLoading(true)
			let photo_url = null
			if (image) {
				photo_url = await handleUploadFile()
			}
			if(props.brand?.id){
				let objects = {
					name,
					active: isActive
				}
				if(photo_url){
					objects = {...objects, photo_url}
				}
				await UpdateBrandMutation({
					variables: {
						id:props.brand?.id,
						setObject: objects
					},
				})
			}else{
				await CreateBrandMutation({
					variables: {
						object: {
							name,
							photo_url
						}
					},
				})
			}
			Swal.fire(`Brand ${props.brand?.id ? "Updated" : "Created"} Successfully`, "", "success").then(() => {
				props.onSubmit()
				props.close()
			})
		} catch (err) {
			Swal.fire("Something went wrong", "", "error")
		} finally {
			setBtnLoading(false)
		}
	}
	useEffect(()=>{
		if(props.brand?.id){
			setName(props.brand.name)
			setActive(props.brand.active)
		}else{
			setName("")
		}
	}, [props.brand])
	return (
		<Modal open={props.open} onClose={() => props.close()}>
			<Modal.Header>
				<Modal.Title>{props.brand?.id ? "Update Brand" : "Create Brand"}</Modal.Title>
			</Modal.Header>
			<Row>
				<Col xs="12">
					<Card>
						<CardBody>
							<Form id="brandform" onSubmit={handleCreateBrand}>
								<Row>
									<Col sm="12">
										<div className="mb-3">
											<Label htmlFor="brandname">Brand Name</Label>
											<Input
												id="brandname"
												name="brandname"
												defaultValue={name}
												type="text"
												className="form-control"
												onChange={(e) => setName(e.target.value)}
												required
											/>
										</div>
									</Col>
								</Row>
								<Row>
									<Col sm="12">
										<div className="mb-3">
											<Label htmlFor="brandimage">Brand Image</Label>
											<FileUploader 
												onChange={setImage}
											/>
										</div>
									</Col>
								</Row>
								<Row>
									<Col sm="12">
										<div className="mb-3">
											<Label htmlFor="commission_percentage">Active</Label>
											<Toggle 
												checked={isActive}
												onChange={(checked)=>setActive(checked)}
												style={{marginLeft: "1rem"}}
											/>
										</div>
									</Col>
								</Row>
								<div className="d-flex flex-wrap gap-2">
									<Button
										color="primary"
										className="btn "
										type="submit"
										disabled={btnLoading}
									>
										Submit
									</Button>
									<Button
										type="button"
										color="secondary"
										className=" "
										onClick={(e) => props.close()}
									>
										Cancel
									</Button>
								</div>
							</Form>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</Modal>
	)
}
EcommerceCreateBrand.propTypes = {
	open: PropTypes.bool,
	close: PropTypes.func,
	onSubmit: PropTypes.func,
	brand: PropTypes.any
}
export default withRouter(EcommerceCreateBrand)
